<div *ngIf="isLoadApp">
    <div class="container-fluid">
        <cp-header *ngIf="isShowheaderFooter"></cp-header>
        <div class="outer-box">
            <div class="inner-box">
                <router-outlet></router-outlet>
            </div>
        </div>
        <cp-footer *ngIf="isShowheaderFooter"></cp-footer>
    </div>
</div>